(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.image-with-text__item');
  if (!items.length) return;

  let activeIndex = 0;
  const bgColor = '#e6eeea';

  function rotateBackground() {
    items.forEach((item, index) => {
      if (index === activeIndex) {
        item.style.setProperty('--iwt-item-bg', bgColor);
        item.classList.add('image-with-text__item--boxed');
      } else {
        item.style.removeProperty('--iwt-item-bg');
        item.classList.remove('image-with-text__item--boxed');
      }
    });

    activeIndex = (activeIndex + 1) % items.length;
  }

  rotateBackground();
  setInterval(rotateBackground, 3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
